// extracted by mini-css-extract-plugin
module.exports = {"col":"TableCell_col__LV0Zt","withEllipsis":"TableCell_withEllipsis__eP10W","bold":"TableCell_bold__ElD84","expandable":"TableCell_expandable__RKxYH"};